// extracted by mini-css-extract-plugin
export default {"pointed":"PaymentHistoryEntries_pointed__WI-yN"};